import React, { useState, useEffect } from "react";
import Table from "../../../../../../components/Table/Table";
import Filters from "../../../../../../components/Filters/Filters";
import "./Members.css";
import { useNavigate } from "react-router-dom";
// Icons
import editIcon from "../../../../../../assets/editIcon.png";
import editInactive from "../../../../../../assets/tokens/editInactive.png";
import toggleActive from "../../../../../../assets/toggleActive.png";
import toggleInactive from "../../../../../../assets/toggleInactive.png";
import trashActive from "../../../../../../assets/tokens/trashActive.png";
import trashInactive from "../../../../../../assets/tokens/trashInactive.png";
import eyeOn from "../../../../../../assets/tokens/eyeOn.png";
// services
import { groupService } from "../../../../../../services/Group";
//utlis
import { formatDate } from "../../../../../../utils/utils";
//Components
import Badge from "../../../../../../components/Badge/Badge";
//hanlde
import HandleResponse from "../../../../../../utils/HandleResponse";
import HandleAlert from "../../../../../../utils/HandleAlert";

const Members = ({ groupId }) => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [columnsShare, setColumnsShare] = useState(1);
  const [columns, setColumns] = useState([]);
  const [members, setMembers] = useState([]);
  const itemsPerPage = 10;
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    fetchColumns();
    setCurrentPage(1); // Reset to first page when filters change
    fetchMembers();
  }, [filters, currentPage, groupId]);

  const fetchMembers = async () => {
    try {
      const response = await groupService.getMembersByGroup(groupId);
      if (response.status === "success") {
        const membersData = response.data.items.map((member) => ({
          ...member,
          applicationDate: formatDate(member.joined_at),
          dateAdded: formatDate(member.created_at),
          status: member.is_deleted ? "inactive" : "active",
        }));
        setMembers(membersData);
        setTotalItems(response.data.total);
      }
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  const filterAndPaginateMembers = (members, filters, page) => {
    let filtered = [...members];

    // Aplicar filtros
    if (filters.status) {
      filtered = filtered.filter(
        (member) =>
          member.status.toLowerCase() === filters.status.toLowerCase(),
      );
    }

    if (filters.type?.value) {
      filtered = filtered.filter(
        (member) =>
          member.role.toLowerCase() === filters.type.value.toLowerCase(),
      );
    }

    setFilteredMembers(filtered);
  };

  const getPaginatedData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredMembers.slice(startIndex, endIndex);
  };

  console.log(
    "Members:",
    members.filter((member) => member.id === 92),
  );

  const fetchColumns = () => {
    let count = 1;
    const columnsData = [
      { header: "Name of member", field: "name" },
      { header: "Role", field: "role" },
      {
        header: "Date added",
        field: "dateAdded",
      },
      {
        header: "Date the application was entered",
        field: "applicationDate",
        style: { minWidth: "200px" },
      },
      {
        header: "Status",
        render: (row) => <Badge status={row.status} />,
      },
    ];

    columnsData.push({
      header: "",
      render: (row) => (
        <button className="action-btn" onClick={() => handleEdit(row)}>
          <img
            src={row.status === "active" ? editIcon : editInactive}
            alt="Edit"
          />
        </button>
      ),
    });

    columnsData.push({
      header: "",
      render: (row) => (
        <button className="action-btn" onClick={() => handleView(row)}>
          <img src={eyeOn} alt="view" />
        </button>
      ),
    });

    columnsData.push({
      header: "",
      render: (row) => (
        <button className="action-btn" onClick={() => handleToggle(row)}>
          <img
            src={row.status === "active" ? toggleActive : toggleInactive}
            alt="Toggle"
          />
        </button>
      ),
    });

    columnsData.push({
      header: "",
      render: (row) => (
        <button className="action-btn" onClick={() => handleDelete(row)}>
          <img
            src={row.status === "active" ? trashActive : trashInactive}
            alt="Delete"
          />
        </button>
      ),
    });

    setColumns(columnsData);
    setColumnsShare(5);
  };

  const handleEdit = (row) => {
    console.log("Edit:", row);
    if (handleIsInactive(row)) return;
    navigate(`/groups/group-details/member/${row.chat_id}`, {
      state: {
        member: row,
        isEditing: true,
      },
    });
  };

  const handleView = (row) => {
    console.log("View:", row);
    navigate(`/groups/group-details/member/${row.chat_id}`, {
      state: {
        member: row,
        isEditing: false,
      },
    });
  };

  const handleToggle = (row) => {
    console.log("Toggle:", row);
    HandleAlert.showConfirmationAlert({
      title: { text: "Toggle", highlight: "member" },
      message: "Do you want to continue with the action?",
      onConfirm: () => {
        HandleAlert.hideAlert();
        handleToggleStatus(row);
      },
    });
  };

  const handleDelete = (row) => {
    console.log("Delete:", row);
    HandleAlert.showConfirmationAlert({
      title: { text: "Delete", highlight: "member" },
      message: "Do you want to continue with the action?",
      onConfirm: () => {
        HandleAlert.hideAlert();
        handleDeleteConfirm(row);
      },
    });
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    filterAndPaginateMembers(members, newFilters, 1);
  };

  const handleToggleStatus = async (row) => {
    console.log("Deactivate:", row);
    try {
      const data = {
        status: row.status === "active" ? "inactive" : "active",
      };
      const response = await groupService.changeStatusMember(
        row.chat_id,
        row.user_id,
        data,
      );
      console.log(response);
      if (response && response.message.includes("exitosamente")) {
        HandleResponse.showSuccessModal({
          title: { text: "Success", highlight: "deactivating" },
          message: "Member deactivated successfully",
          confirmText: "Accept",
          onConfirm: () => {
            fetchMembers();
            HandleResponse.hideModal();
          },
        });
      } else {
        HandleResponse.showErrorModal({
          title: { text: "Error", highlight: "deactivating" },
          message: "Failed to deactivate member",
          confirmText: "Understood",
          onConfirm: () => {
            HandleResponse.hideModal();
          },
        });
      }
    } catch (error) {
      console.error("Error deactivating member:", error);
      HandleResponse.showErrorModal({
        title: { text: "Error to ", highlight: "deactivate" },
        message: "Failed to deactivate member",
        confirmText: "Understood",
        onConfirm: () => {
          HandleResponse.hideModal();
        },
      });
    }
  };

  const handleDeleteConfirm = async (row) => {
    if (handleIsInactive(row)) return;
    try {
      const response = await groupService.deleteUserFromGroup(groupId, row.id);
      if (response.status === "success") {
        HandleResponse.showSuccessModal({
          title: { text: "Success", highlight: "deleting" },
          message: "Member deleted successfully",
          confirmText: "Accept",
          onConfirm: () => {
            fetchMembers();
            HandleResponse.hideModal();
          },
        });
      } else {
        HandleResponse.showErrorModal({
          title: { text: "Error", highlight: "deleting" },
          message: "Failed to delete member",
          confirmText: "Understood",
          onConfirm: () => {
            HandleResponse.hideModal();
          },
        });
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      HandleResponse.showErrorModal({
        title: { text: "Error to ", highlight: "delete" },
        message: "Failed to delete member",
        confirmText: "Understood",
        onConfirm: () => {
          HandleResponse.hideModal();
        },
      });
    }
  };

  const handleIsInactive = (row) => {
    if (row.status === "inactive") {
      HandleResponse.showErrorModal({
        title: { text: "Error", highlight: "editing" },
        message: "Member is inactive",
        confirmText: "Understood",
        onConfirm: () => {
          HandleResponse.hideModal();
        },
      });
      return true;
    }
    return false;
  };

  return (
    <div className="members-container">
      <div className="filters-section">
        <Filters
          filters={[
            {
              id: "status",
              label: "Status",
              type: "checkbox",
              options: ["Active", "Inactive"],
            },
            {
              id: "type",
              label: "Role",
              type: "dropdown",
              options: [
                {
                  label: "Owner",
                  value: "Owner",
                },
                {
                  label: "Administrator",
                  value: "Administrator",
                },
                {
                  label: "Member",
                  value: "Member",
                },
              ],
            },
            {
              id: "dateAdded",
              label: "Date added",
              type: "date",
              placeholder: "dd/mm/yyyy - dd/mm/yyyy",
            },
            {
              id: "applicationDate",
              label: "Date of application entry",
              type: "date",
              placeholder: "dd/mm/yyyy - dd/mm/yyyy",
            },
          ]}
          onApplyFilters={handleFilterChange}
        />
      </div>
      <div className="table-section">
        <Table
          columns={columns}
          data={members}
          columnsShare={columnsShare}
          currentPage={currentPage}
          totalItems={totalItems}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default Members;
